export function validatePincode(pincode: unknown): boolean {
  const regex = /^\d{6}$/;
  return regex.test(pincode);
}

export function replaceFileName(url: string, appendText: string): string {
  const regex = /(?=\.[^.]+$)/g;
  return url ? url.replace(regex, appendText) : '';
}
